module.exports = __webpack_public_path__ + "static/media/header-key.3e721029.png";